import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';


@Component({
    standalone: false,
    selector: 'unity-modal',
    templateUrl: './unity-modal.component.html',
    styleUrls: ['./unity-modal.component.scss']
})
export class UnityModalComponent {
    @Input() title: string;
    @Input() primaryAction: string;
    @Input() primaryActionEnabled: boolean = true;
    @Input() secondaryAction?: string;
    @Input() secondaryActionEnabled: boolean = true;
    @Input() tertiaryAction?: string;
    @Input() tertiaryActionEnabled: boolean = true;
    @Input() backAction?: string;
    @Input() hideFooter?: boolean = false; // If true, hides all actions in the footer

    @Output() public onPrimaryAction: EventEmitter<any> = new EventEmitter();
    @Output() public onSecondaryAction: EventEmitter<any> = new EventEmitter();
    @Output() public onTertiaryAction: EventEmitter<any> = new EventEmitter();
    @Output() public onBackAction: EventEmitter<any> = new EventEmitter();
    @Output() public onClose: EventEmitter<any> = new EventEmitter();

    primaryActionClicked() {
        this.onPrimaryAction.emit()
    }       
};